<template>
  <div class="admin-pis__queue">
    <div class="admin-pis__queue__list">
      <div
        v-for="counter in counters"
        :key="counter.id"
        :class="{
          'admin-pis__queue__item--disabled': counter.is_disabled,
          'admin-pis__queue__item--active': counter.id === currentCounter.id,
        }"
        class="admin-pis__queue__item"
      >
        <div class="vertical-data-group">
          <div class="admin-pis__queue__label">{{ counter.group_name }}</div>
          <div class="data-group">
            <span class="data">{{ counter.short_name }}</span>
            <span class="data">{{ counter.current_count || '&mdash;' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    currentCounter: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      counters: 'queueing/counters',
    }),
  },
  async created () {
    this.$store.dispatch('queueing/getStatus')
  },
}
</script>
